import { useRefresh } from 'react-admin';
import CheckIcon from '@mui/icons-material/Check';
import { Button, CircularProgress } from '@mui/material';
import { useCallback, useState } from 'react';
import { useLogEffect } from '@/util/useLogEffect';
import { adminRpcClient } from '@/providers/backendClient';

type ForceTranscriptionProps = {
  recordingId: string;
};

export const ForceTranscriptionButton = ({
  recordingId,
}: ForceTranscriptionProps) => {
  const [isUpdating, setIsUpdating] = useState(false);

  const refresh = useRefresh();

  const onForceTranscription = useCallback(async () => {
    setIsUpdating(true);

    const result = (await adminRpcClient(
      'PUBLIC_ADMIN_therapistRecordings_transcribeOne',
      [recordingId],
    ).catch((err: Error) => ({
      _rpcClientError: err.message,
    }))) as {
      success?: boolean;
      message?: string;
      error?: string | { message?: string };
      _rpcClientError?: string;
    };

    setIsUpdating(false);

    refresh();

    const failureText =
      result._rpcClientError ??
      (result.success === false
        ? String(result.message ?? 'Transcription request failed')
        : undefined) ??
      (typeof result.error === 'string'
        ? result.error
        : result.error?.message);

    if (failureText) {
      alert('Error transcribing Note input: ' + failureText);
    }
  }, [recordingId, refresh]);

  useLogEffect('RECORDING ID', recordingId);

  return (
    <Button
      disabled={isUpdating}
      onClick={onForceTranscription}
      startIcon={
        !isUpdating ? <CheckIcon /> : <CircularProgress size="1rem" />
      }
    >
      {!isUpdating ? 'Retry Transcription' : 'Transcribing'}
    </Button>
  );
};
